import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GungModalService } from '../../services/gung-modal/gung-modal.service';
import { MfaService } from '../../services/mfa/mfa.service';
import { AuthService } from '../../services/auth/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'lib-add-user-mfa-modal',
  templateUrl: './add-user-mfa-modal.component.html',
  styleUrl: './add-user-mfa-modal.component.scss',
  standalone: false
})
export class AddUserMfaModalComponent {
  delegate: GungModalService;
  componentId: string;

  qrCodeImage: string;
  deviceName: string = '';
  code: string;
  invalidSetupCode = false;

  public form: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    protected mfaService: MfaService,
    protected authService: AuthService,
    protected formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.initMfaSetup();
    this.form = this.formBuilder.group({
      deviceName: this.formBuilder.control('', Validators.required),
      code: this.formBuilder.control('', [Validators.required, Validators.maxLength(6)])
    });
  }

  initMfaSetup() {
    this.mfaService.initiateSetup().subscribe(resp => {
      this.qrCodeImage = resp.qrCodeImage;
    });
  }

  close() {
    this.delegate.modalRef.get(AddUserMfaModalComponent.name).close('Closed');
  }

  add() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const rawFormData = this.form.getRawValue();
    this.code = rawFormData.code;
    this.mfaService.completeSetup(rawFormData.code, rawFormData.deviceName).subscribe({
      next: () => {
        this.delegate.modalRef.get(AddUserMfaModalComponent.name).close('');
      },
      error: () => {
        this.invalidSetupCode = true;
      }
    });
  }
}
